"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryOnlyConfigurationStore = exports.MemoryStore = void 0;
class MemoryStore {
    constructor() {
        this.store = {};
        this.initialized = false;
    }
    get(key) {
        var _a;
        return (_a = this.store[key]) !== null && _a !== void 0 ? _a : null;
    }
    getKeys() {
        return Object.keys(this.store);
    }
    isInitialized() {
        return this.initialized;
    }
    setEntries(entries) {
        this.store = Object.assign({}, entries);
        this.initialized = true;
    }
}
exports.MemoryStore = MemoryStore;
class MemoryOnlyConfigurationStore {
    constructor() {
        this.servingStore = new MemoryStore();
        this.initialized = false;
    }
    init() {
        this.initialized = true;
        return Promise.resolve();
    }
    get(key) {
        return this.servingStore.get(key);
    }
    getKeys() {
        return this.servingStore.getKeys();
    }
    async isExpired() {
        return true;
    }
    isInitialized() {
        return this.initialized;
    }
    async setEntries(entries) {
        this.servingStore.setEntries(entries);
        this.initialized = true;
    }
}
exports.MemoryOnlyConfigurationStore = MemoryOnlyConfigurationStore;
//# sourceMappingURL=memory.store.js.map